import httpManager from "@/app/shared/utils/httpManager";
import { TABLE_PAGE_SIZE } from "@/app/shared/utils/constants";
import {
  ReportTypes,
  CustomerSupportReportTypes,
  CustomerSupportReportTypesNames,
} from "@/app/reports/utils/enums";

export async function fetchUserManagementType({ filters, page = 1 } = {}) {
  const [year, month] = filters?.month?.split("-");

  let query = "";
  if (filters.entity) query += `entity=${filters.entity}&`;
  query += `portfolio=${filters.portfolio}&`;
  if (filters.base) query += `base=${filters.base}&`;
  query += `year=${year}&`;
  query += `month=${month}`;

  const offset = (page - 1) * TABLE_PAGE_SIZE;
  const limit = TABLE_PAGE_SIZE;

  const type = CustomerSupportReportTypesNames[CustomerSupportReportTypes.UsersManagement];

  const url = `/reports/${ReportTypes.CustomerSupport}/?offset=${offset}&limit=${limit}&type=${type}&${query}`;

  const response = await httpManager.get(url);
  return response?.data;
}
